import { DateRangePicker, Loader } from "rsuite";
import CardC from "../../../components/CustomCard/CardC";
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import createURL from "../../../libs/peticiones/url";
import peticionBack from "../../../libs/peticiones/peticionBack";
import Chart from "react-apexcharts";

type Dato = {
    total: number,
    type: string,
    type_id: string
}
type Tipo = {
    y: number,
    x: string,
    id: string
}

const defConfig = {
    options: {
        chart: {
            type: "bar",
            events: {
                dataPointSelection: (_e, _chart, _config) => {}
            }
        },
        xaxis: {
            categories: []
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            distributed: true,
            dataLabels: {
                position: 'top',
            }
          }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ["#19165F"]
            }
        },
        legend: {
          show: false
        },
        series: []
    } as ApexOptions,
    series: [] as any[]
}

export default function TypeChart({ materia, setHook }: { materia?: Tipo, setHook?: Function }){
    const [dates, setDates] = useState<Date[]|null>(null);
    const [config, setConfig] = useState(defConfig);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dates, materia]);

    async function getData() {
        let url = createURL("/reportes/files/count/type", [
            { name: "startDate", value: cleanDate(0)},
            { name: "endDate", value: cleanDate(1) },
            { name: "subject", value: materia?.id||"" },
        ]);
        const cpy = { ...defConfig } 

        if(!materia){
            cpy.options = {
                chart: { type: "pie" },
                legend: {
                    position: 'bottom'
                },
            }
        }

        setLoading(true);
        const res = await peticionBack({}, url, "GET", false);
        if(res && res.length > 0){
            const names: string[] = [], values: any[] = [];
            res.sort((a:Dato, b:Dato) => a.type.localeCompare(b.type)).forEach((d: Dato) => {
                names.push(d.type);
                values.push(materia ? { x: d.type, y: d.total, id: d.type_id } : d.total);
            });
            if(materia){
                cpy.options.xaxis = {
                    type: 'category',
                    categories: names,
                    labels: { show: true }
                }
                cpy.series = [{ name: "total", data: values }];
            }else{
                cpy.options.labels = names;
                cpy.series = values;
            }
            if(cpy.options.chart){
                cpy.options.chart.events = {
                    dataPointSelection: (_e, _c, config) => {
                        findType(config, res);
                    }
                }
            }
        }else{
            cpy.series = [];
        }
        setConfig(cpy);
        setLoading(false);
    }
    
    function findType(config: any, data: Dato[]){
        if(setHook){
            if(materia){
                setHook(config.w.config.series[0].data[config.dataPointIndex]);
            }else{
                const find = data.find((d: Dato) => d.type === config.w.config.labels[config.dataPointIndex]);
                setHook({id: find?.type_id, x: find?.type, y: find?.total});
            }
        }
    }

    function cleanDate(pos: number){
        if(!dates) return "";
        let str = dates[pos].toISOString().split("T")[0];
        if(pos === 0) str += "T00:00:00Z";
        else  str += "T23:59:59Z";
        return str;
    }

    function getTile(){
        let tt = "Sentencias por ";
        if(materia){
            tt+= "Juicio de la matería " + materia?.x ;
        }else tt += "Materia";
        return tt;
    }
    return(
        <CardC className="mb-4">
            <div className="d-flex flex-md-row flex-column justify-content-md-between mb-2">
                <h6>{getTile()}</h6>
                <DateRangePicker
                    size="xs" 
                    appearance="subtle"
                    placeholder="Fechas" 
                    style={{ width: "auto" }} 
                    onChange={(e)=> setDates(e)}
                    preventOverflow
                    placement="auto"
                />
            </div>
            <div className="border">
                {
                    loading ? 
                    <div className="text-center py-auto" style={{ minHeight: "315px" }}><Loader center size="md"/></div> :
                    <Chart options={config.options} series={config.series} type={materia ? "bar" : "pie"} height={300} />
                }
                    
            </div>
        </CardC>
    )
}